import React from 'react';
import PropTypes from 'prop-types';

const SquareButton = ({
  buttonClassName = null,
  onClick,
  children,
  className = ''
}) => {
  const buttonClasses = buttonClassName || 'w-6 h-6';
  return (
    // A block wrapper around an inline-level button grows by the line box's
    // descender, and that invisible strip took the clicks meant for whatever
    // sat under it, the locate button under the zoom pill. Flex fits the
    // wrapper to the button.
    <div className={`flex ${className}`}>
      <button
        type="button"
        className={`flex justify-center items-center bg-white shadow-lg pointer-events-auto ${buttonClasses}`}
        onClick={onClick}
      >
        {children}
      </button>
    </div>
  );
};

SquareButton.propTypes = {
  buttonClassName: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default SquareButton;
